import React from 'react';
import { FooterRights } from '../../atoms/texts/FooterRights';
import { Container } from '../../container/Container';

export const Footer: React.FC = () => (
  <Container justify="center" padding={{ base: '4', md: '6' }}>
    <FooterRights fontSize="xs" text="Copyright(C) MYUKKE. All Rights Reserved." />
  </Container>
);
